// Thrid-party
import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';

// Types
import { FileUploaderSteps } from './FileUploaderFlow';

// Utils
import { formatMessage } from '@/utils/i18n';

export type Props = {
  currentStep: FileUploaderSteps;
  onCancel: () => void;
  onImport: () => void;
  onUpload: () => void;
  onContinue: () => void;
};

const FileUploaderActions: React.FC<Props> = ({ onCancel, currentStep, onImport, onUpload, onContinue }) => (
  <div className="file-uploader-actions">
    <Button variant="secondary" onClick={onCancel}>
      {formatMessage('Common.Cancel')}
    </Button>

    <div className="d-flex gap-2">
      {currentStep !== FileUploaderSteps.UPLOAD && (
        <Button variant="secondary" onClick={onUpload}>
          {formatMessage('Modal.PortfolioUpload.UpdateFile')}
        </Button>
      )}
      {currentStep === FileUploaderSteps.DEFINE_HEADERS ? (
        <Button variant="primary" onClick={onContinue}>
          {formatMessage('Common.Continue')}
        </Button>
      ) : (
        <Button variant="primary" disabled={currentStep !== FileUploaderSteps.IMPORT} onClick={onImport}>
          {currentStep === FileUploaderSteps.IMPORT ? formatMessage('Modal.PortfolioUpload.Import') : formatMessage('Common.Continue')}
        </Button>
      )}
    </div>
  </div>
);

export default FileUploaderActions;
